export default "__VITE_ASSET__BhVDx6j7__"